import React, { useState, useEffect, Fragment } from "react";
import {
    Button,
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    TextField,
    Typography,
} from "@material-ui/core";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../help/Api";
import TotalCard from "../../../../components/TotalCard";
import { useHistory } from "react-router-dom";

import { insh as inshst } from "../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import LockIcon from "@material-ui/icons/Lock";

import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";

import { sto } from "../../../../Context/InshData";

import { insh } from "../../../../Context/InshData";
import InvoiceOilFilter from "./InvoiceOilFilter";
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial
} from '../../../../St/Reports/UseStyle';
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function InvoiceOilItems(props) {
    const {
        fromQountity,
        setfromQountity,
        selectOilType,
        subInfo,
        changInfo,
        getrowDataCurrencie,
        AutoOptions,
        idata,
        onChangeData
    } = props;
    const clasAo = useStylesAuto();

    const clasup = useStylesUp();
    const clashd = useStylesHed();
    const clasBA = useStylesBA();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();


    const { t } = useTranslation(["forms", "translation"]);

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: colors.green[300],
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >
                    {AutoOptions?.permType?.id === 4 ?
                        (
                            <>
                                <InvoiceOilFilter {...{
                                    fromQountity,
                                    setfromQountity,
                                    selectOilType,
                                }} />
                                <Fragment>
                                    <Grid item container justifyContent="center" xs={12}>

                                        <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                            <TextField fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="symbol"
                                                label={t("item-name")}
                                                className={clasTF.rootSale}
                                                InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                type="text"
                                                name="symbol"
                                                value={subInfo.symbol}
                                            /></Grid>


                                        {fromQountity.select.id == 1 &&
                                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                <TextField fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    id="number"
                                                    label={"اللترات"}
                                                    className={clasTF.rootSaleOil}
                                                    InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                    InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                    type="number"
                                                    name="val1"
                                                    value={subInfo.val1}
                                                /></Grid>

                                        }
                                        {fromQountity.select.id == 1 &&
                                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                <TextField fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    id="symbol"
                                                    label={t("price")}
                                                    className={clasTF.rootSaleOil}
                                                    InputProps={{ className: claslbl.clrSaleOil }}
                                                    InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                    type="number"
                                                    name="totJust1"
                                                    value={subInfo?.totJust1}
                                                    onChange={changInfo("totJust1")}

                                                /></Grid>

                                        }
                                        {fromQountity.select.id == 2 &&
                                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                <TextField fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    id="totJust"
                                                    label={t("price")}
                                                    className={clasTF.rootSaleOil}
                                                    InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                    InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                    type="number"
                                                    name="totJust"
                                                    value={subInfo?.totJust}
                                                /></Grid>

                                        }
                                        {fromQountity.select.id == 2 &&
                                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                <TextField fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    id="val1"

                                                    label={"اللترات"}
                                                    className={clasTF.rootSaleOil}
                                                    InputProps={{ className: claslbl.clrSaleOil, }}
                                                    InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                    type="number"
                                                    name="valOil"
                                                    value={subInfo.valOil}
                                                    onChange={changInfo("valOil")}

                                                /></Grid>

                                        }
                                        <br />
                                        <br />
                                        <br />
                                        {/* <br /> */}
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Button
                                                fullWidth
                                                autoFocus
                                                variant="contained"
                                                color="primary"
                                                className={clasTF.rootSaleOil}

                                                onClick={getrowDataCurrencie}

                                                style={{
                                                    background: colors.green[500],
                                                    ...{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                    },
                                                }}
                                            //startIcon={<ArrowDownwardIcon />}
                                            >
                                                {"متابعة"}
                                            </Button>
                                        </Grid>

                                    </Grid>

                                </Fragment>

                            </>
                        ) :
                        (
                            <>

                                <Fragment>
                                    <Grid item container justifyContent="center" xs={12}>

                                        <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                            <TextField fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="symbol"
                                                label={t("item-name")}
                                                className={clasTF.rootSale}
                                                InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                type="text"
                                                name="symbol"
                                                value={subInfo.symbol}
                                            /></Grid>


                                        <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                            <TextField fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="symbol"
                                                label={"البيان"}
                                                className={clasTF.rootSale}
                                                InputProps={{ className: claslbl.clrSaleOil }}
                                                InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                type="text"
                                                name="notes"
                                                value={idata?.notes}
                                                onChange={onChangeData("notes")}
                                                /></Grid>


                                        <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                            <TextField fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="symbol"
                                                label={t("price")}
                                                className={clasTF.rootSaleOil}
                                                InputProps={{ className: claslbl.clrSaleOil }}
                                                InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                type="number"
                                                name="totJust2"
                                                value={subInfo?.totJust2}
                                                onChange={changInfo("totJust2")}

                                            /></Grid>
                                        <br />
                                        <br />
                                        <br />
                                        {/* <br /> */}
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Button
                                                fullWidth
                                                autoFocus
                                                variant="contained"
                                                color="primary"
                                                className={clasTF.rootSaleOil}

                                                onClick={getrowDataCurrencie}

                                                style={{
                                                    background: colors.green[500],
                                                    ...{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                    },
                                                }}
                                            //startIcon={<ArrowDownwardIcon />}
                                            >
                                                {"متابعة"}
                                            </Button>
                                        </Grid>

                                    </Grid>

                                </Fragment>

                            </>
                        )

                    }


                </Container>


            </Grid>
        </React.Fragment>
    );
}
